module.exports = __webpack_public_path__ + "img/03mazda-cx9.2575b27b.png";